import React from "react";
import Translate from "../../../i18n/i18nTranslate";

export default function PreviewButtons({ onSuccesClick, AnswersFontScales }) {
  return (
    <div className="flex justify-center items-center flex-col">
      <p
        className="my-2 text-red-500 font-bold"
        style={{ fontSize: AnswersFontScales }}
      >
        (*){" "}
        {Translate(
          " ile işaretli olanların doldurulması zorunludur.",
          "Components.Preview.PreviewButtons.Must_Filled"
        )}
      </p>
      <button
        onClick={() => onSuccesClick()}
        style={{
          fontSize: AnswersFontScales,
          padding: AnswersFontScales,
          height: "auto",
        }}
        className="btn m-2 mb-8 btn-success  text-white/90"
      >
        {Translate("Tamamla", "Components.Preview.PreviewButtons.Complete")}
      </button>
    </div>
  );
}
